<div class="d-flex flex-column search-instructions">
  <p data-automation-id="search-refinement" translate>Refinement</p>
  <p data-automation-id="search-instructions" translate>Search Instructions</p>
</div>
